import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import CategoryReelTabBar from "../../components/CategoryReelTabBar";
import { colors } from "theme/Theme";
import ProductsInReel from "./ProductsInReel";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { device } from "theme/Breakpoints";
import { useInView } from "react-intersection-observer";
type Size = {
  width: string;
  left: string;
};
const ProductReel = () => {
  const resize = useWindowDimensions();
  const containerRef = useRef<HTMLDivElement>();
  const [size, setSize] = useState<Size>({ width: "0px", left: "0px" });
  const [inViewRef, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const setRefs = useCallback(
    (node) => {
      containerRef.current = node;
      inViewRef(node);
    },
    [inViewRef]
  );
  useEffect(() => {
    if (containerRef.current) {
      let parentWidth = containerRef.current.offsetWidth;
      let bodyWidth = document.body.offsetWidth;
      let _size: Size = {
        width: `${bodyWidth}px`,
        left: `-${(bodyWidth - parentWidth) / 2}px`,
      };
      setSize(_size);
    }
  }, [resize]);

  return (
    <ProductReelContainer ref={setRefs}>
      <Background size={size} />
      {inView && (
        <>
          <CategoryReelTabBar />
          <ProductsInReel />
        </>
      )}
    </ProductReelContainer>
  );
};

const ProductReelContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: 100%;
  background-color: ${colors.newGray};
  padding: 20px 0;
  @media only screen and (${device.tablet}) {
    margin: 30px 0;
  }
`;

const Background = styled.div<{ size: Size }>`
  z-index: -1;
  top: 0;
  bottom: 0;
  width: ${(props) => props.size.width};
  left: ${(props) => props.size.left};
  position: absolute;
  background-color: ${colors.newGray};
`;
ProductReelContainer.displayName = "ProductReelContainer";

export default ProductReel;
